import Config from './Config'
export default Config;